import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Trusted Center for Faith and Community",
    description: [
        "Welcome to Siraj Islamic Center, your spiritual home and hub for community growth. We are committed to fostering unity, providing educational programs, and offering guidance rooted in the teachings of Islam.",
    ],
    points: [
        "Daily Congregational Prayers",
        "Qur'an and Islamic Studies Classes",
        "Community Outreach and Charity Programs",
        "Marriage and Counseling Services",
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        alt1: "Islamic Center About Image 1",
        alt2: "Islamic Center About Image 2",
        alt3: "Islamic Center About Image 3",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;